import { getRouteApi } from '@tanstack/react-router'
import { type DefaultValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Loading from '@/components/Loading'
import BasicLayout from '@/components/common/BasicLayout/BasicLayout'
import { toast } from '@/hooks/useToast'

import SchoolYearForm from '../components/SchoolYearForm'
import { type SchoolYearFormPayload } from '../constants/school-year-payload'
import useAddSchoolYear from '../mutations/useAddSchoolYear'

const routeApi = getRouteApi('/_auth/school-settings/years/add')

const defaultValues: DefaultValues<SchoolYearFormPayload> = {
  firstSemester: {
    from: undefined,
    to: undefined
  },
  secondSemester: {
    from: undefined,
    to: undefined
  }
}

const SchoolYearAddView = () => {
  const navigate = routeApi.useNavigate()
  const { t } = useTranslation(['schoolSettings', 'common'])

  const {
    mutate: addSchoolYear,
    isPending: isAddSchoolYearPending,
    formErrors
  } = useAddSchoolYear({
    onSuccess: response => {
      toast({
        variant: 'success',
        title: t('toast.school-year-add-success')
      })
      navigate({
        to: '/school-settings/years/$yearId',
        params: {
          yearId: response.id
        }
      })
    },
    onError: () => {
      toast({
        variant: 'error',
        title: t('toast.school-year-add-error')
      })
    }
  })

  return (
    <BasicLayout
      breadcrumbs={[
        {
          title: t('common:navigation.school-settings'),
          to: '/school-settings'
        },
        {
          title: t('header.add-new-school-year')
        }
      ]}
      header={t('header.add-new-school-year')}
      moduleName={t('common:header.administration')}
    >
      <Loading spinning={isAddSchoolYearPending}>
        <SchoolYearForm
          defaultValues={defaultValues}
          onSubmit={addSchoolYear}
          errors={formErrors}
        />
      </Loading>
    </BasicLayout>
  )
}

export default SchoolYearAddView
